<template>
  <div class="bg-gray-100 p-10 px-6  md:p-20">
    <p class="pb-6 text-xl md:text-2xl font-serif">{{ $t('home.services.our-services') }}</p>
    <div data-aos="fade-up" data-aos-duration="700">
      <div class="grid md:grid-cols-2 xl:grid-cols-5 gap-6">
        <!-- Sportello d'ascolto -->
        <div class="rounded-lg flex flex-col items-center border border-gray-400 gap-6 p-10 bg-white">
          <div class="bg-blue-600 rounded-full h-20 w-20 flex items-center justify-center">
            <Icon class="text-white" name="mdi:ear-hearing" size="60"></Icon>
          </div>
          <p class="text-base md:text-xl font-serif text-center md:min-h-14">{{ $t('home.services.listening-desk') }}</p>
          <p class="text-sm 2xl:text-base text-center h-16 md:h-10 xl:h-24">{{ $t('home.services.listening-desk-description') }}</p>
          <NuxtLink :to="localePath('/services/listening-desk')" class="w-full">
            <Button class="bg-blue-600 border-2 w-full">
              <div>{{ $t('home.services.learn-more') }}</div>
            </Button>
          </NuxtLink>
        </div>
        <!-- Supporto didattico -->
        <div class="rounded-lg flex flex-col items-center border border-gray-400 gap-6 p-10 bg-white">
          <div class="bg-green-600 rounded-full h-20 w-20 flex items-center justify-center">
            <Icon class="text-white" name="mdi:book-open-variant" size="60"></Icon>
          </div>
          <p class="text-base md:text-xl font-serif text-center md:min-h-14">{{ $t('home.services.educational-support') }}</p>
          <p class="text-sm 2xl:text-base text-center h-16 md:h-10 xl:h-24">{{ $t('home.services.educational-support-description') }}</p>
          <NuxtLink :to="localePath('/services/educational-support')" class="w-full">
            <Button class="bg-green-600 border-2 w-full">
              <div>{{ $t('home.services.learn-more') }}</div>
            </Button>
          </NuxtLink>
        </div>
        <!-- Percorsi formativi -->
        <div class="rounded-lg flex flex-col items-center border border-gray-400 gap-6 p-10 bg-white">
          <div class="bg-orange-600 rounded-full h-20 w-20 flex items-center justify-center">
            <Icon class="text-white" name="mdi:school-outline" size="60"></Icon>
          </div>
          <p class="text-base md:text-xl font-serif text-center md:min-h-14">{{ $t('home.services.training-courses') }}</p>
          <p class="text-sm 2xl:text-base text-center h-16 md:h-10 xl:h-24">{{ $t('home.services.training-courses-description') }}</p>
          <NuxtLink :to="localePath('/services/training-paths')" class="w-full">
            <Button class="bg-orange-600 border-2 w-full">
              <div>{{ $t('home.services.learn-more') }}</div>
            </Button>
          </NuxtLink>
        </div>
        <!-- Servizi psicologici -->
        <div class="rounded-lg flex flex-col items-center border border-gray-400 gap-6 p-10 bg-white">
          <div class="bg-red-600 rounded-full h-20 w-20 flex items-center justify-center">
            <Icon class="text-white" name="mdi:brain" size="60"></Icon>
          </div>
          <p class="text-base md:text-xl font-serif text-center md:min-h-14">{{ $t('home.services.psychological-services') }}</p>
          <p class="text-sm 2xl:text-base text-center h-16 md:h-10 xl:h-24">{{ $t('home.services.psychological-services-description') }}</p>
          <NuxtLink :to="localePath('/services/psychological-services')" class="w-full">
            <Button class="bg-red-600 border-2 w-full">
              <div>{{ $t('home.services.learn-more') }}</div>
            </Button>
          </NuxtLink>
        </div>
        <!-- Laboratori -->
        <div class="rounded-lg flex flex-col items-center border border-gray-400 gap-6 p-10 bg-white">
          <div class="bg-purple-600 rounded-full h-20 w-20 flex items-center justify-center">
            <Icon class="text-white" name="mdi:palette" size="60"></Icon>
          </div>
          <p class="text-base md:text-xl font-serif text-center md:min-h-14">{{ $t('home.services.laboratories') }}</p>
          <p class="text-sm 2xl:text-base text-center h-16 md:h-10 xl:h-24">{{ $t('home.services.laboratories-description') }}</p>
          <NuxtLink :to="localePath('/services/workshops')" class="w-full">
            <Button class="bg-purple-600 border-2 w-full">
              <div>{{ $t('home.services.learn-more') }}</div>
            </Button>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style></style>